import React from "react"
import { useShallow } from "zustand/react/shallow"
import parse from "html-react-parser"
import dayjs from "dayjs"
import { useUserSettings } from "api/hooks"
import useAuthoringComments from "../../../../../hooks/actions/useAuthoringCommentActions"
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"
import "./Comments.scss"

const resultsTableIdSet = ["period", "BaselineReportingGroup", "OutcomeRptGroup", "ReportedEvents"]

const Comments = () => {
  const { comments } = useAuthoringComments()
  const { data: userSettings } = useUserSettings()

  const { formView, formSection } = useAuthoringViewStore(
    useShallow((state) => ({
      formView: state.formView,
      formSection: state.formSection,
    }))
  )

  const displayComments = () => {
    const filteredComments = comments
      .filter((comment) => {
        if (comment.form_section && comment.form_view && formView?.id !== "global") {
          // if form section and view matches then render the comment
          if (comment.form_section === formSection.id && comment.form_view === formView?.id) {
            return true
          } else {
            return false
          }
        }
        return true
      })
      .filter((comment) => {
        if (document.getElementById(comment.field_key + "-container")) return true
        else if (document.getElementById(comment.field_key + "-field-container")) return true
        else if (formSection.id === "results" && resultsTableIdSet.some((idPart) => comment.field_key.includes(idPart)))
          return true
        return false
      })
      .filter((comment) => {
        if (formView.id === "eudra" && comment.field_key.startsWith("root_protocol")) return false
        else if ((formView.id === "eupas" || formView.id === "ctis") && comment.field_key.startsWith("root_result"))
          return false
        return true
      })
      .map((comment) => (
        <tr key={comment.id}>
          <td>{comment.field_name}</td>
          <td>{parse(comment.text)}</td>
          <td>{parse(comment.author_fullname)}</td>
          <td>{dayjs(comment.action_date).format(userSettings?.date_format)}</td>
          <td>{comment.resolved ? "Yes" : "No"}</td>
          <td>{comment.tags?.join(", ")}</td>
        </tr>
      ))

    return filteredComments
  }

  if (comments?.length === 0) return null

  return (
    <div className="page-preview-comments">
      <div className="authoring-form-section-panel-h1">Comments</div>
      <table>
        <thead>
          <tr>
            <th>Field Name</th>
            <th>Comment Text</th>
            <th>Added By</th>
            <th>Action Date</th>
            <th>Resolved</th>
            <th>Tags</th>
          </tr>
        </thead>
        <tbody>{displayComments()}</tbody>
      </table>
    </div>
  )
}

export default Comments
